"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * E-Verify Account Service
 * API for management of E-Verify Accounts
 *
 * The version of the OpenAPI document: 1.0.135
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubCategoryTypeToJSON = exports.SubCategoryTypeFromJSONTyped = exports.SubCategoryTypeFromJSON = exports.SubCategoryType = void 0;
/**
 * Enum for Employer Category sub category values
 * @export
 * @enum {string}
 */
var SubCategoryType;
(function (SubCategoryType) {
    SubCategoryType["NATIVEAMERICANTRIBE"] = "NATIVE_AMERICAN_TRIBE";
    SubCategoryType["STATEORLOCALGOVT"] = "STATE_OR_LOCAL_GOVT";
    SubCategoryType["SURETY"] = "SURETY";
    SubCategoryType["NONEOFTHEABOVE"] = "NONE_OF_THE_ABOVE";
    SubCategoryType["INSTITUTEOFHIGHERLEARNING"] = "INSTITUTE_OF_HIGHER_LEARNING";
})(SubCategoryType = exports.SubCategoryType || (exports.SubCategoryType = {}));
function SubCategoryTypeFromJSON(json) {
    return SubCategoryTypeFromJSONTyped(json, false);
}
exports.SubCategoryTypeFromJSON = SubCategoryTypeFromJSON;
function SubCategoryTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.SubCategoryTypeFromJSONTyped = SubCategoryTypeFromJSONTyped;
function SubCategoryTypeToJSON(value) {
    return value;
}
exports.SubCategoryTypeToJSON = SubCategoryTypeToJSON;
